//Principal
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { ChamadoService } from 'src/app/shared/services/chamado.service';
import { SubCategoriaService } from 'src/app/shared/services/sub-categoria.service';
import { SubCategoria } from 'src/app/shared/models/subCategorias/sub-categoria';

@Component({
  selector: 'app-funcoes-admin',
  templateUrl: './funcoes-admin.component.html',
  styleUrls: ['./funcoes-admin.component.scss'],
  standalone: true,
  imports: [angularCommonImports,libsCommonImports,convivaCommonImports]
})

export class FuncoesAdminComponent implements OnInit {

  public formFuncoesAdmin!: FormGroup;
  public formFuncoesAdminSubCategorias!: FormGroup;
  public get form() {
    return this.formFuncoesAdmin.controls;
  }
  public get formSubCategoria() {
    return this.formFuncoesAdminSubCategorias.controls;
  }
  public resultadoAtualizarStatus: string = '';
  public resultadoAtualizarSubCategoria: string = '';
  public subCategorias: any[] = [];

  constructor(
    private spinnerService: NgxSpinnerService,
    private chamadoService: ChamadoService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private toastr: ToastrService,
    private subCategoriaService: SubCategoriaService,
  ){
  }

  ngOnInit() {
    this.inicializarFormularios();
    this.carregarSubCategorias();
  }

  private inicializarFormularios() {
    // Inicialize seus FormGroups aqui
    this.formFuncoesAdmin = new FormGroup({});
    this.formFuncoesAdminSubCategorias = new FormGroup({
      codigoSubCategoria: new FormControl(''),
      descSubCategoria: new FormControl('')
    });
  }

  private async carregarSubCategorias() {
    this.spinnerService.show();
    try {
      const response = await lastValueFrom(this.subCategoriaService.getSubCategoria());
      if (response.isSucess) {
        this.subCategorias = response.data.map((item: any) => ({
              ...item,
              descricaoSubCategoria: `${item.codigoSubCategoria} - ${item.descricaoSubCategoria}`
            }));
      } else {
        this.toastr.error('Erro ao carregar sub-categorias');
      }
    } catch (error) {
      this.ConvivaErrors.handleResultError(error);
    } finally {
      this.spinnerService.hide();
    }
  }

  public async AtualizarStatusChamados()
  {
    this.spinnerService.show();
    const response = await lastValueFrom(this.chamadoService.FixStatusChamadosEnvolvidos())
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.toastr.success('Atualização realizada com sucesso');
    this.spinnerService.hide();

    this.resultadoAtualizarStatus = response.data.replace(/<\/br>/g, '\n');
  }

  public async AtualizarDescSubCategoria()
  {
    this.spinnerService.show();
    
    this.resultadoAtualizarSubCategoria = '';

    const codigoSubCategoria = this.formFuncoesAdminSubCategorias.get('codigoSubCategoria')?.value;
    const descSubCategoria = this.formFuncoesAdminSubCategorias.get('descSubCategoria')?.value;

    // Validação dos campos
    if (!codigoSubCategoria || codigoSubCategoria === 0 || codigoSubCategoria === '' || 
        !descSubCategoria || descSubCategoria === '') {
      this.toastr.error('Código e descrição da subcategoria são obrigatórios');
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.subCategoriaService.fixDescricaoSubCategoria(codigoSubCategoria, descSubCategoria))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    
    this.toastr.success('Atualização realizada com sucesso');

    // Limpeza dos campos após sucesso na atualização
    this.formFuncoesAdminSubCategorias.get('codigoSubCategoria')?.setValue('');
    this.formFuncoesAdminSubCategorias.get('descSubCategoria')?.setValue('');
    this.carregarSubCategorias();

    this.spinnerService.hide();

    this.resultadoAtualizarSubCategoria = response.data.replace(/<\/br>/g, '\n');
  }
}
